import { useRef } from "react";
import { Button as AntdButton } from "antd";
import { PrinterOutlined } from "@ant-design/icons";
import { useReactToPrint } from "react-to-print";

import FicheDeclarationSinistre from "../../../docs/FicheDeclarationSinistre";

const FicheDeclarationTab = ({ sinistre }) => {
    const printRef = useRef(null);
    const handlePrint = useReactToPrint({ content: () => printRef.current });

    if (!sinistre) {
        return null;
    }

    return (
        <div className="card-body">
            <div className="container">
                <div className="grid-item">
                    <div id="ficheDeclarationSinistre">
                        <FicheDeclarationSinistre ref={printRef} sinistre={sinistre} />
                    </div>
                </div>
            </div>
            <br />
            <AntdButton
                onClick={handlePrint}
                type="primary"
                style={{ background: "green" }}
                icon={<PrinterOutlined />}
            >
                Imprimer
                <br />
                <br />
                <br />
            </AntdButton>
        </div>
    );
};

export default FicheDeclarationTab;
